/**
 * 筛选类型映射
 * @author  韦胜健
 * @date    2019/9/27 10:44
 */
const DYNAMIC_FILTER_TYPE = {
	input: 'input',
	picklist: 'input',
	date: 'date',
	number: 'number',
	lov: 'lov',
}

/**
 * 默认值
 * @author  韦胜健
 * @date    2019/9/27 10:45
 */
const DEFAULT = {
	type: DYNAMIC_FILTER_TYPE.input
}

class DynamicFilter {

	value = {
		val: null,          //筛选值：普通文本，值列表，下拉值，可能是数组
		start: null,        //筛选值，数字范围起始值或时间范围起始值
		end: null,          //筛选值，数字范围结束值或时间范围结束值
	};

	field;                  //字段，可能是数组
	title;                  //字段标题，可能是数组
	type;                   //筛选类型：input，date，number，lov，select
	column;                 //列对象
	lov;                    //值列表类型
	parentLovType;          //父值列表类型
	parentLovValue;         //父值列表值

	constructor(linkFilterOption, context) {
		// 组件实例
		this.context = context || {}
		linkFilterOption = {...linkFilterOption}
		linkFilterOption.type = linkFilterOption.type || DYNAMIC_FILTER_TYPE.input
		linkFilterOption.column = linkFilterOption.column || {}
		linkFilterOption.column.externalData = linkFilterOption.column.externalData || {}

		if (LinkUtils.typeOf(linkFilterOption.value) === 'string') {
			linkFilterOption.value = {val: linkFilterOption.value}
		}
		Object.assign(this, DEFAULT, linkFilterOption)
	}

	get $lov() {
		return this.context.$lov || window.Vue.prototype.$lov
	}

	async toFiltersRaw(autoOption) {
		if (!this.field) {
			/*全字段查询*/
			if (!autoOption) {
				console.log(this)
				console.error('全字段查询必须传入AutoOption')
				return []
			}

			const getLinkFilterOptions = async () => {
				console.log('getLinkFilterOptions')
				while (autoOption.linkFilterOptions == null) {
					await autoOption.$lv.$utils.delay(50)
				}
				return autoOption.linkFilterOptions
			}

			const linkFilterOptions = await getLinkFilterOptions()
			const ret = []
			const val = this.value.val

			if (!val) return []

			for (let i = 0; i < linkFilterOptions.length; i++) {
				const {type, lov, field} = linkFilterOptions[i]
				switch (type) {
					case 'lov':
						let lovs = await this.$lov.getLovByType(lov)
						if (!!lovs && lovs.length > 0) {
							const matchLovs = lovs.filter(item => item.name.indexOf(val) > -1)
							if (!!matchLovs && matchLovs.length > 0) {
								ret.push({
									property: field,
									operator: 'in',
									value: `[${matchLovs.map(item => item.val).join(',')}]`
								})
							}
						}
						break;
					case 'input':
					case 'picklist':
					case 'number':
						ret.push({
							property: field,
							operator: 'LIKE',
							value: val
						})
						break;
				}
			}
			return ret
		} else {
			/*单字段查询*/
			const ret = []
			const temp = {property: this.field}
			const {start, end, val} = this.value

			switch (this.type) {
				case 'number':
					if (!!start || start === 0) ret.push(Object.assign({}, temp, {operator: '>=', value: start}))
					if (!!end || end === 0) ret.push(Object.assign({}, temp, {operator: '<=', value: end}))
					break;
				case 'date':
					if (!!start) ret.push(Object.assign({}, temp, {
						operator: '>=',
						value: `${start} 00:00:00`,
						type: 'date'
					}))
					if (!!end) ret.push(Object.assign({}, temp, {
						operator: '<=',
						value: `${end} 23:59:59`,
						type: 'date'
					}))
					break;
				case 'input':
					const startWithEqual = !!val && val.charAt(0) === '=';
					!!val && ret.push(Object.assign({}, temp, {
						operator: (!!this.column.exactQuery || (startWithEqual)) ? '=' : 'LIKE',
						value: (startWithEqual && !this.column.exactQuery) ? val.substring(1) : val
					}))
					break;
				case 'lov':
					!!val && ret.push(Object.assign({}, temp, {operator: '=', value: val}))
					break;
			}
			return ret
		}
	}

	async toText() {
		let ret;
		switch (this.type) {
			case 'number':
				if (!this.value.start && this.value.start !== 0 && !this.value.end && this.value.end !== 0) return null
				ret = []
				ret.push(this.title)
				if (!(!this.value.start && this.value.start !== 0)) ret.push(`${LinkVue.$t('LinkFilter.largerThan')} ${this.value.start}`)
				if (!(!this.value.end && this.value.end !== 0)) ret.push(`${LinkVue.$t('LinkFilter.smallerThan')} ${this.value.end}`)
				return ret.join(' ')
			case 'date':
				if (!this.value.start && !this.value.end) return null
				ret = []
				ret.push(this.title)
				!!this.value.start && ret.push(`${LinkVue.$t('LinkFilter.largerThan')} ${this.value.start}`)
				!!this.value.end && ret.push(`${LinkVue.$t('LinkFilter.smallerThan')} ${this.value.end}`)
				return ret.join(' ')
			case 'input':
				if (!this.value.val) return null
				return `${this.title} ${LinkVue.$t('LinkFilter.like')} “${this.value.val}”`
			case 'lov':
				if (!this.value.val) return null
				return `${this.title} ${LinkVue.$t('LinkFilter.equal')} “${await this.$lov.getNameByTypeAndVal(this.lov, this.value.val)}”`
		}
	}

	copy() {
		const {start, end, val} = this.value
		return new DynamicFilter(Object.assign({}, this, {start, end, val}))
	}

	clearValue() {
		Vue.prototype.$set(this, 'value', {val: null, start: null, end: null})
	}
}

const DynamicFilterMixin = {
	props: {
		dynamicFilter: {},
		searchIcon: {type: Boolean},
	},
	methods: {
		async confirm() {
			await this.$lv.nextTick()
			this.getValue()
			this.emit()
		},
		emit(val) {
			this.$emit('confirm', this.dynamicFilter)
		},
	}
}

export {DynamicFilter, DynamicFilterMixin, DYNAMIC_FILTER_TYPE}
